import {ReservationLocation} from '@wix/ambassador-table-reservations-v1-reservation-location/types'
import {ControllerFlowAPI} from '@wix/yoshi-flow-editor'

import {reservationLocationsService} from '../../services/reservationLocationsService'

import {reservationLocationMock} from './reservationLocation'

export const getReservationLocationsMock = async (
  flowAPI: ControllerFlowAPI,
): Promise<ReservationLocation[]> => {
  let reservationLocationsFromApi: ReservationLocation[] = []

  try {
    reservationLocationsFromApi = await reservationLocationsService.getReservationLocations(flowAPI)
  } catch (e) {
    flowAPI.errorHandler.getResolvedError(e)
  }

  const atLeastOneLocationHasEnabledOnlineReservation = reservationLocationsFromApi?.some(
    (reservationLocation) =>
      reservationLocation?.configuration?.onlineReservations?.onlineReservationsEnabled,
  )

  return reservationLocationsFromApi?.length
    ? atLeastOneLocationHasEnabledOnlineReservation
      ? reservationLocationsFromApi
      : reservationLocationsFromApi.map((r) => ({
          ...r,
          configuration: {
            ...r.configuration,
            onlineReservations: {
              ...r.configuration?.onlineReservations,
              onlineReservationsEnabled: true,
            },
          },
        }))
    : [reservationLocationMock]
}
